module.exports = __webpack_public_path__ + "img/slide-1-en.537e181c.png";